var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.to ? 'router-link' : 'button',{tag:"component",class:['app-btn', `app-btn--${_vm.variant}`],style:(_vm.btnStyle),attrs:{"to":_vm.to},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default"),(_vm.arrow)?_c('span',{staticClass:"arrow"},[_vm._v("→")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }